import React, { useState } from "react";
import { Input, Button, DatePicker, Checkbox, Select, Tabs, Form } from "antd";
import { MailOutlined, FileImageOutlined, SmileOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { TabPane } = Tabs;

const Announcement: React.FC = () => {
    const [activeTab, setActiveTab] = useState("Announcement");
    const [form] = Form.useForm();

    const onFinish = (values: any) => {
        console.log("Submitted Values: ", values);
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ marginTop: 20 }}
        >
            <Form.Item
                label="Title"
                name="title"
                rules={[{ required: true, message: "Please enter a title!" }]}
            >
                <Input placeholder="Type your question here" />
            </Form.Item>

            <Form.Item
                label="Description"
                name="description"
                rules={[{ required: true, message: "Please enter details!" }]}
            >
                <TextArea rows={4} placeholder="Enter Announcement Details here" />
            </Form.Item>

            <Form.Item name="notifyEmployees" valuePropName="checked">
                <Checkbox>Notify employees</Checkbox>
            </Form.Item>
        </Form>
    );
};

export default Announcement;
